import { useTranslation } from 'react-i18next'
import AlreadyRegisteredWrapper from 'app/auth/components/onboarding/steps/shared/AlreadyRegisteredWrapper'
import { Box, Typography } from '@mui/material'

const AlreadyRegisteredAxNumber = () => {
  const { t } = useTranslation()

  return (
    <AlreadyRegisteredWrapper>
      <Box my={2}>
        <Typography component='div' variant='body1' style={{ whiteSpace: 'pre-line' }}>
          {t('Auth.AlreadyRegisteredMessageAxNumber1')}
        </Typography>
      </Box>
    </AlreadyRegisteredWrapper>
  )
}

export default AlreadyRegisteredAxNumber
